import { useState } from 'react';

export const usePagination = (initialRowsPerPage = 25, initialPage = 0) => {
  const [page, setPage] = useState(initialPage);
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  return { rowsPerPage, setRowsPerPage, page, setPage, handleChangePage, handleChangeRowsPerPage };
};

export default usePagination;
